import { _BasketFooter } from 'autogen/swagger/all';
import { GeneralExceptionError } from 'autogen/translation-keys/trans-website-shared-error';
import { InputWPlaceholder } from '../../modules/input-w-placeholder';
import Voucher from './voucher';

export default class UpdateBasketFooter {
    constructor() {
        this.basketFooterWrapper = $('[data-js="basket-footer"]');
    }

    init() {}

    async updateBasketFooter() {
        try {
            const partialViewResponse = await _BasketFooter();

            if (!partialViewResponse) return;

            this.basketFooterWrapper.html(partialViewResponse);
            this.rebindScripts();
        } catch (error) {
            console.error(error);
            toast.error(t(GeneralExceptionError));
        }
    }

    rebindScripts() {
        this.rebindInputWPlaceholder();
        this.rebindVoucher();
        (async () => {
            const { default: Selection } = await import(/* webpackChunkName: "selection" */ 'modules/selection');
            Selection.bind(this.basketFooterWrapper);
        })();
    }

    rebindInputWPlaceholder() {
        this.basketFooterWrapper.find('[data-js="InputWithLabel"]').each(() => {
            const inputWPlaceholder = new InputWPlaceholder($('[data-js="InputWithLabel"]'));
            inputWPlaceholder.init();
        });
    }

    rebindVoucher() {
        this.basketFooterWrapper.find('.js-voucher').each((i, item) => {
            const voucher = new Voucher(item);
            voucher.init();
        });
    }
}

export function rebindBasketFooter() {
    const updateBasketFooter = new UpdateBasketFooter();
    updateBasketFooter.updateBasketFooter();
}
